<template>
    <div class="ppv2-space-y-4">
        <InfoMessageBox
            class="ppv2-mt-2"
            :title="$t('messageBox.depositForm.start.title')"
            color="info"
            :customIcon="customIconStart"
        />

        <div class="ppv2-flex ppv2-flex-col ppv2-space-y-4">
            <div class="ppv2-relative ppv2-p-4 ppv2-cursor-pointer">
                <div class="ppv2-absolute ppv2-top-2 ppv2-right-2">
                    <BaseSwitch v-model="formData.deposit" required :disabled="false" :error="hasError ? 'Invalid' : ''" />
                </div>
                <div>
                    <div class="ppv2-text-base ppv2-text-gray-800 poppinsMedium">
                        <BaseLabel :label="$t('depositForm.fields.isDeposit.label')" />
                    </div>
                    <div class="ppv2-flex ppv2-items-center ppv2-space-x-2 ppv2-mt-1 ppv2-text-xs ppv2-text-gray-500">
                        <BaseParagraphe>
                            {{ $t('depositForm.fields.isDeposit.description') }}
                        </BaseParagraphe>
                    </div>
                </div>

                <BaseRadioGroup
                    v-model="formData.accompte_type"
                    :label="$t('depositForm.fields.depositType.label')"
                    :description="$t('depositForm.fields.depositType.description')"
                    class="ppv2-mt-6"
                    :options="DepositTypeOptions"
                    required
                >
                    <template #leftIcon> </template>
                </BaseRadioGroup>

                <InfoMessageBox
                    v-if="formData.accompte_type == 'percentage'"
                    class="ppv2-mt-3"
                    :message="$t('depositForm.fields.depositType.options.percent.description', { symbol: $symbolCurrency })"
                    color="info"
                />

                <InfoMessageBox
                    v-if="formData.accompte_type == 'amount'"
                    class="ppv2-mt-3"
                    :message="$t('depositForm.fields.depositType.options.amount.description')"
                    color="info"
                />

                <BaseInput
                    v-model="formData.accompte"
                    :label="
                        formData.accompte_type == 'percentage'
                            ? $t('depositForm.fields.depositValuePercent.label')
                            : $t('depositForm.fields.depositValueAmount.label')
                    "
                    class="ppv2-mt-6"
                    :placeholder="
                        formData.accompte_type == 'percentage'
                            ? $t('depositForm.fields.depositValuePercent.placeholder')
                            : $t('depositForm.fields.depositValueAmount.placeholder')
                    "
                    required
                >
                    <template #leftIcon>
                        <svg
                            v-if="formData.accompte_type == 'percentage'"
                            class="ppv2-w-4 ppv2-h-4 ppv2-text-gray-700"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M19 5.5L5 19.5M9 7C9 8.38071 7.88071 9.5 6.5 9.5C5.11929 9.5 4 8.38071 4 7C4 5.61929 5.11929 4.5 6.5 4.5C7.88071 4.5 9 5.61929 9 7ZM20 18C20 19.3807 18.8807 20.5 17.5 20.5C16.1193 20.5 15 19.3807 15 18C15 16.6193 16.1193 15.5 17.5 15.5C18.8807 15.5 20 16.6193 20 18Z"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <svg
                            v-else
                            class="ppv2-w-4 ppv2-h-4 ppv2-text-gray-700"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M4 10.5H16M4 14.5H13M19 6.50003C17.5771 5.20768 15.7222 4.49427 13.8 4.50003C12.7625 4.51308 11.7378 4.73037 10.7843 5.13949C9.83083 5.5486 8.96727 6.14153 8.24296 6.88442C7.51864 7.6273 6.94776 8.50559 6.56291 9.46913C6.17806 10.4327 5.98678 11.4626 6 12.5C6 16.9 9.5 20.5 13.8 20.5C15.8 20.5 17.6 19.7 19 18.5"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </template>
                </BaseInput>

                <BaseLabel :label="$t('depositForm.fields.depositIsRequested.label')" class="ppv2-mt-6" />
                <BaseCheckbox
                    v-model="formData.is_deposit_checkout_fo_active"
                    :label="$t('depositForm.fields.depositIsRequested.options.unicInSite.label')"
                    :description="$t('depositForm.fields.depositIsRequested.options.unicInSite.description')"
                    class="ppv2-mt-4"
                />
                <BaseCheckbox
                    v-model="formData.is_deposit_checkout_bo_contributor_active"
                    :label="$t('depositForm.fields.depositIsRequested.options.viaPaymentLink.label')"
                    :description="$t('depositForm.fields.depositIsRequested.options.viaPaymentLink.description')"
                    class="ppv2-mt-3"
                />
            </div>
        </div>
    </div>
</template>

<script>
import InfoMessageBox from '../../../Shared/InfoMessageBox.vue'
import BaseParagraphe from '../../../Shared/BaseParagraphe.vue'
import BaseRadioGroup from '../../../Shared/BaseRadioGroup.vue'
import BaseCheckbox from '../../../Shared/BaseCheckbox.vue'
import BaseSwitch from '../../../Shared/BaseSwitch.vue'
import BaseLabel from '../../../Shared/BaseLabel.vue'
import BaseInput from '../../../Shared/BaseInput.vue'

export default {
    name: 'DepositForm',
    components: {
        InfoMessageBox,
        BaseParagraphe,
        BaseRadioGroup,
        BaseCheckbox,
        BaseSwitch,
        BaseLabel,
        BaseInput,
    },
    data() {
        return {
            customIconStart: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 5L5 19M9 6.5C9 7.88071 7.88071 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.88071 4 9 5.11929 9 6.5ZM20 17.5C20 18.8807 18.8807 20 17.5 20C16.1193 20 15 18.8807 15 17.5C15 16.1193 16.1193 15 17.5 15C18.8807 15 20 16.1193 20 17.5Z" stroke="#021832" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`,
            customIconLink: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 3H21M21 3V9M21 3L10 14M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`,
            hasError: false,
            formData: {
                deposit: false,
                accompte_type: '',
                accompte: null,
                is_deposit_checkout_fo_active: false,
                is_deposit_checkout_bo_contributor_active: false,
            },
        }
    },
    computed: {
        establishment() {
            return this.$store.getters['establishment/establishment']
        },
        DepositTypeOptions() {
            return [
                { label: this.$t('depositForm.fields.depositType.options.amount.label'), value: 'amount' },
                { label: this.$t('depositForm.fields.depositType.options.percent.label'), value: 'percentage' },
            ]
        },
    },
    watch: {
        establishment: {
            handler() {
                this.initializeForm()
            },
            immediate: true,
            deep: true,
        },
        formData: {
            handler(newVal) {
                this.$emit('update', newVal)
            },
            deep: true,
        },
    },
    methods: {
        initializeForm() {
            const fields = [
                'deposit',
                'accompte_type',
                'accompte',
                'is_deposit_checkout_fo_active',
                'is_deposit_checkout_bo_contributor_active',
            ]
            fields.forEach((field) => {
                if (this.establishment.hasOwnProperty(field)) {
                    this.formData[field] = this.establishment[field]
                }
            })
        },
    },
}
</script>

<style scoped></style>
